
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import CardItemValue from "@/components/card/CardItemValue.vue";

  @Component({
    components: {
      CardItemValue,
      CardItemTitle,
    },
  })
  export default class CardItemChipsContainer extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: Array, required: true }) readonly collection!: any[];

    get isDefaultShown(): boolean {
      return this.collection.length === 0;
    }
  }
